<template>
    <p>&nbsp;</p>
</template>
<script>
import { apiUrl } from "../vars";
import { appUrl } from "../vars";
import auth from "../auth";
import { removeChatMixin } from "../plugins/removeChatMixin";

export default {
  created() {
    let o = {
      u: this.$route.query.u,
      t: this.$route.query.t
    };
    axios
      .post(apiUrl + "/api/verify-mobile", o)
      .then(response => {
        if (response.data.hasOwnProperty('success')){
	        this.$router.push({
		        name: "signin",
		        params: {
			        phone:
				        "Seu número de telemóvel foi verificado com sucesso!"
		        }
	        });
        }
        else {
          this.$router.push({
            name: "home",
            params: {
              phone:
                "Falha ao validar o número de telemóvel. Se o problema persistir, entre em contato com nosso suporte."
            }
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/VerifyMobile.vue